module.exports = {"430623101":"三封寺镇","430623102":"治河渡镇","430623103":"北景港镇","430623104":"鲇鱼须镇","430623106":"万庾镇","430623110":"插旗镇","430623111":"注滋口镇","430623112":"操军镇","430623114":"东山镇","430623119":"梅田湖镇","430623120":"章华镇","430623121":"禹山镇","430623201":"新河乡","430623207":"团洲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430623.json
// module id = 1989
// module chunks = 0